// extracted by mini-css-extract-plugin
module.exports = {"paper":"a3-qr-10x10_paper__1TBmz","page":"a3-qr-10x10_page__1z4T4","label":"a3-qr-10x10_label__3Ix5f"};